import { IResponse } from '~/services/api/types';
import { privateAxios } from '../requestsCollection';
import { IFile } from './types';

export const uploadFile = (data: FormData): IResponse<IFile> =>
  privateAxios({
    method: 'post',
    url: 'File',
    data,
  });

export default {};
